import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface Props {
  children: React.ReactNode;
  onClickOk: () => void | Promise<void>;
  onClickCancel: () => void;
}

/**
 * 確認モーダル OK / キャンセル を選択させる
 * @param param0
 * @returns
 */
function ConfirmModal({ children, onClickOk, onClickCancel }: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      active
      additionalClassName="popupfr340"
      displayCloseButton={false}
      onClose={() => {
        /* do nothing */
      }}
    >
      <div>{children}</div>
      <div className="mb0">
        <input type="button" className="red-button" value={t('OK').toString()} onClick={onClickOk} />
        <input type="button" className="red-button ml10" value={t('キャンセル').toString()} onClick={onClickCancel} />
      </div>
    </Modal>
  );
}

export default ConfirmModal;
